import React from 'react';
import PropTypes from 'prop-types';
import { Sparkles } from 'lucide-react';

/**
 * Skill-Pille (Okt 2026, wie im Werbespot, Motion-Kit `.eo-pill`).
 *
 * Neutral fuer jeden Skill, lila nur fuer den, der gerade passt (Suchtreffer,
 * gemeinsamer Skill) — dann mit Funkeln davor. Vorher gab es die Pille nur
 * lokal in der Profilkarte, kleiner und blasser als im Spot.
 *
 * - match: der passende Skill (lila, mit Sparkles)
 * - size:  md (14px, Profilkarte) | sm (12.5px, Zeilen)
 */

const SIZES = {
  md: 'gap-1.5 px-3.5 py-[7px] text-sm leading-[18px]',
  sm: 'gap-1 px-2.5 py-1 text-meta',
};

// Eine eigene max-w-… aus className muss gewinnen. Stand max-w-full mit in der
// Liste, setzte sich im CSS max-w-full durch (Okt 2026: die Pille in der
// Suchtrefferzeile wurde 185 px breit und schob Name und Klasse aus der Zeile).
const Pill = ({ children, match = false, size = 'md', className = '', ...rest }) => (
  <span
    className={[
      'inline-flex items-center rounded-full border font-medium whitespace-nowrap',
      /(^|\s)max-w-/.test(className) ? '' : 'max-w-full',
      SIZES[size] || SIZES.md,
      match
        ? 'bg-primary-soft border-primary/35 text-primary'
        : 'bg-surface-raised border-border text-foreground-2',
      className,
    ].join(' ')}
    {...rest}
  >
    {match && <Sparkles className={size === 'sm' ? 'h-3 w-3 shrink-0' : 'h-3.5 w-3.5 shrink-0'} aria-hidden="true" />}
    <span className="truncate">{children}</span>
  </span>
);

Pill.propTypes = {
  children: PropTypes.node.isRequired,
  match: PropTypes.bool,
  size: PropTypes.oneOf(['md', 'sm']),
  className: PropTypes.string,
};

export default Pill;
